import styled from 'styled-components';

import { NamedIcon } from '@telialt/common-icon/src';
import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const InsuranceVasWrapper = styled.div`
    background-color: #fbfbfb;
    padding: ${getPurpurSpacing('300')};
    margin-top: ${getPurpurSpacing('250')};
`;

export const InsuranceVasTitle = styled.div`
    font-size: 1rem;
    margin-bottom: ${getPurpurSpacing('200')};
    flex-basis: 100%;
`;

export const InsuranceVasSubtitle = styled.span`
    font-size: 0.875rem;
`;

export const InsuranceFeatureContainerGrid = styled.div`
    margin-top: ${getPurpurSpacing('200')};
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    ${purpurMedia('md')`
        grid-template-columns: repeat(3, 1fr);
    `};
`;

export const InsuranceIconContainerFlex = styled.div`
    display: flex;
    margin-bottom: 0.625rem;
`;

export const InsuranceVasIcon = styled(NamedIcon)`
    min-width: 1.25rem;
    font-size: 1.25rem;
    margin-right: 0.625rem;
`;

export const InsuranceVasIconTitle = styled.span`
    font-size: 0.875rem;
`;
